
setTimeout(() => {
document.getElementById("text-box-2523074").addEventListener("keyup", valueBordadoBolso);

function valueBordadoBolso() {
  var campo_bolso = document.getElementById("text-box-2523074").value;
  console.log(campo_bolso)
  if(campo_bolso != ""){
    var cantidad_producto =  document.getElementsByClassName("cant_product")[0].value;
    agregarComplemento("43614280319045", cantidad_producto);
   
  }else{
    eliminarSiEsUnico("43614280319045", "0");
  }
  
}
}, "1500");


function agregarComplemento(variantId, qty) {
  
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
       if(cart.items.length == 0){
        //console.log(variantId)
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: variantId,
                  quantity: qty
                })
              })
              .then(res => res.json())
              .then(data => {             
                //console.log("✅ Complemento agregado:", data);
                // aquí puedes actualizar el carrito lateral o redirigir
                // window.location.href = '/cart'; // si quieres mandar al carrito
              })
              .catch(err => console.error("❌ Error al agregar complemento:", err));
       }else{

       }
      

      })
    .catch(err => console.error("❌ Error:", err));
 
}

function eliminarComplemento(variantId, qty) {
  console.log(variantId)
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: qty
    })
  })
  .then(res => res.json())
  .then(data => {
    //console.log("✅ Complemento agregado:", data);
    // aquí puedes actualizar el carrito lateral o redirigir
    // window.location.href = '/cart'; // si quieres mandar al carrito
  })
  .catch(err => console.error("❌ Error al agregar complemento:", err));
}
/**
 * Elimina la variante si es la única en el carrito
 * @param {Number} variantId - ID de la variante del complemento
 */
function eliminarSiEsUnico(variantId) {
  
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
       
      if (cart.items.length == 1 && cart.items[0].variant_id == variantId) {
       
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        })
        .then(r => r.json())
        .then(data => {

          //console.log("🗑️ Complemento eliminado automáticamente:", data);
          window.location.reload(false);


        });
      }
    })
    .catch(err => console.error("❌ Error:", err));
}

/**
 * Intercepta todas las llamadas fetch
 * y ejecuta la revisión después de un cambio de carrito
 */
(function() {
  const originalFetch = window.fetch;
  window.fetch = async function() {
    
    const response = await originalFetch.apply(this, arguments);
 
    // revisamos si la URL está relacionada al carrito
    const url = arguments[0];
  
    if (typeof url === "string" && (
        url.includes("/cart/change") 
    )) {
       
      // damos un pequeño delay para que Shopify actualice bien
      setTimeout(() => eliminarSiEsUnico("43614280319045"), 500); 
      // 👆 cambia por el variant_id de tu complemento
    }

    return response;
  };
})();